import { render, staticRenderFns } from "./invoiceEntityConfig.vue?vue&type=template&id=ed953560&scoped=true"
import script from "./invoiceEntityConfig.vue?vue&type=script&lang=js"
export * from "./invoiceEntityConfig.vue?vue&type=script&lang=js"
import style0 from "./invoiceEntityConfig.vue?vue&type=style&index=0&id=ed953560&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed953560",
  null
  
)

export default component.exports